import { render, staticRenderFns } from "./TrainScore.vue?vue&type=template&id=bae55354&scoped=true&"
import script from "./TrainScore.vue?vue&type=script&lang=js&"
export * from "./TrainScore.vue?vue&type=script&lang=js&"
import style0 from "./TrainScore.vue?vue&type=style&index=0&id=bae55354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae55354",
  null
  
)

export default component.exports